import React, { ComponentProps } from 'react'
import { FieldUi } from './ui/field-ui'

export interface FieldProps extends ComponentProps<typeof FieldUi> {}

export const Field = (props: FieldProps) => {
  return <FieldUi {...props} />
}
